// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__KPeYL","modal":"Modal_modal__ITGg1","slide-down":"Modal_slide-down__gc5Zc"};